import BaseRequest from './BaseRequest';

const schema = 'order-transaction';
/**
 * key base on host:port
 */
export default class OrderTransactionRequest extends BaseRequest {
  /**
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchAllOrderTransaction(params) {
    const url = `${schema}/all`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.pos
	 * @param {string} params.count
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchUserOrderTransactions(params) {
    const url = `${schema}/range-order-transactions`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.id
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchIdOrderTransactions(params) {
    const url = `${schema}/ids?id=${params}`;
    return this.get(url);
  }
}
